export const FETCH_START = 'fetchStartCheckTokenTelegram'
export const FETCH_END = 'fetchEndCheckTokenTelegram'
export const SENDING_MESSAGE_START = 'sendingMessageStart'
export const SENDING_MESSAGE_END = 'sendingMessageEnd'